export enum LocationType {
  ImportFromCSV = 1,
  MasterLocation = 2,
  ManualEntry = 3,
}
